import React, { useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import Swal from "sweetalert2";
import axiosInstance from "../../Shared/axiosInstance.js"; // استخدم instance من Shared

export default function AllNotifications() {
  const API_BASE = "/StockNotification";

  const [notifications, setNotifications] = useState([]);
  const [load, setLoad] = useState(false);

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  // جلب كل الإشعارات
  async function getAllNotifications(page = 1, size = 10) {
    setLoad(true);
    try {
      const { data } = await axiosInstance.get(
        `${API_BASE}?pageNumber=${page}&pageSize=${size}`
      );
      setNotifications(data?.data || []);
      setTotalPages(data?.totalPages || 0);
      setTotalCount(data?.totalCount || 0);
      setCurrentPage(data?.currentPage || 1);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
    } finally {
      setLoad(false);
    }
  }

  // حذف إشعار
  async function handleDelete(notificationId) {
    try {
      const result = await Swal.fire({
        title: "هل أنت متأكد؟",
        text: "سيتم حذف الإشعار نهائيًا!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "نعم، احذفه!",
        cancelButtonText: "إلغاء",
      });

      if (result.isConfirmed) {
        setLoad(true);
        const response = await axiosInstance.delete(`${API_BASE}/${notificationId}`);

        await Swal.fire({
          title: "تم الحذف!",
          text: response.data.message || "تم حذف الإشعار بنجاح.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        getAllNotifications(currentPage, pageSize);
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
      Swal.fire({
        title: "خطأ!",
        text: error.response?.data?.message || "فشل حذف الإشعار. حاول مرة أخرى.",
        icon: "error",
      });
    } finally {
      setLoad(false);
    }
  }

  // Pagination Handlers
  function handlePageChange(newPage) {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
    getAllNotifications(newPage, pageSize);
  }

  function handlePageSizeChange(newSize) {
    setPageSize(newSize);
    setCurrentPage(1);
    getAllNotifications(1, newSize);
  }

  useEffect(() => {
    getAllNotifications(1, pageSize);
  }, []);

  if (load) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center flex-column">
        <Bars height="80" width="80" color="#2563eb" ariaLabel="loading" />
        <p className="mt-3" style={{ color: "#64748b", fontSize: "18px" }}>
          جاري تحميل الإشعارات...
        </p>
      </div>
    );
  }

  return (
    <div className="container py-5" style={{ maxWidth: "1400px" }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
        <div>
          <h2
            style={{
              color: "#2563eb",
              fontWeight: "700",
              fontSize: "28px",
              marginBottom: "4px",
            }}
          >
            إشعارات المخزون
          </h2>
          <small style={{ color: "#64748b", fontSize: "14px" }}>
            عرض {notifications.length} من {totalCount} إشعار
          </small>
        </div>

        <div>
          <select
            value={pageSize}
            onChange={(e) => handlePageSizeChange(Number(e.target.value))}
            style={{
              padding: "10px 16px",
              border: "1px solid #bfdbfe",
              borderRadius: "6px",
              fontSize: "14px",
              color: "#475569",
              fontWeight: "600",
              outline: "none",
              cursor: "pointer",
              background: "#fff",
            }}
          >
            <option value="5">5 في الصفحة</option>
            <option value="10">10 في الصفحة</option>
            <option value="20">20 في الصفحة</option>
            <option value="50">50 في الصفحة</option>
          </select>
        </div>
      </div>

      {/* Info Bar */}
      {notifications.length > 0 && (
        <div className="mb-3">
          <span style={{ color: "#64748b", fontSize: "14px" }}>
            عرض {((currentPage - 1) * pageSize) + 1} إلى{" "}
            {Math.min(currentPage * pageSize, totalCount)} من {totalCount} إشعار
          </span>
        </div>
      )}

      {/* Table */}
      {notifications?.length > 0 ? (
        <>
          <div className="table-responsive">
            <table
              className="table mb-0"
              style={{
                border: "1px solid #dbeafe",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
                textAlign: "center",
              }}
            >
              <thead style={{ background: "#dbeafe" }}>
                <tr>
                  <th style={thStyle}>#</th>
                  <th style={thStyle}>المنتج</th>
                  <th style={thStyle}>الفئة</th>
                  <th style={thStyle}>البراند</th>
                  <th style={thStyle}>الكمية</th>
                  <th style={thStyle}>الحد الأدنى</th>
                  <th style={thStyle}>التاريخ</th>
                  <th style={thStyle}>الحالة</th>
                  <th style={thStyle}>تم الإرسال إلى</th>
                  <th style={thStyle}>العمليات</th>
                </tr>
              </thead>

              <tbody>
                {notifications.map((n, index) => (
                  <tr
                    key={n.id}
                    style={{
                      background: index % 2 === 0 ? "#f8fafc" : "#ffffff",
                    }}
                  >
                    <td style={tdStyle}>
                      {((currentPage - 1) * pageSize) + index + 1}
                    </td>

                    <td style={{ ...tdStyle, fontWeight: 600 }}>
                      {n.productName} {n.productDescription}
                    </td>

                    <td style={tdStyle}>{n.categoryName}</td>
                    <td style={tdStyle}>{n.brandName}</td>

                    <td style={tdStyle}>
                      <span
                        style={{
                          background: "#fef3c7",
                          color: "#92400e",
                          padding: "4px 10px",
                          borderRadius: "4px",
                          fontSize: "13px",
                          fontWeight: "600",
                        }}
                      >
                        {n.quantityAtNotification}
                      </span>
                    </td>

                    <td
                      style={{
                        ...tdStyle,
                        color: "#dc2626",
                        fontWeight: 600,
                      }}
                    >
                      {n.minStockLevel}
                    </td>

                    <td style={{ ...tdStyle, fontSize: "16px" }}>
                      {n.notificationDate}
                    </td>

                    <td style={tdStyle}>
                      <span
                        style={{
                          background:
                            n.status === "Pending" ? "#fecaca" : "#bbf7d0",
                          color:
                            n.status === "Pending" ? "#991b1b" : "#14532d",
                          padding: "4px 10px",
                          borderRadius: "4px",
                          fontSize: "13px",
                          fontWeight: "600",
                        }}
                      >
                        {n.status === "Pending" ? "قيد الانتظار" : "تم الإرسال"}
                      </span>
                    </td>

                    <td style={{ ...tdStyle, fontSize: "14px" }}>
                      {n.emailSentTo || "لا يوجد"}
                    </td>

                    <td style={tdStyle}>
                      <button
                        style={actionBtnStyle("#dc2626")}
                        onClick={() => handleDelete(n.id)}
                      >
                        <i className="bi bi-trash me-1"></i> حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-4">
              <div style={{ color: "#64748b", fontSize: "14px" }}>
                صفحة {currentPage} من {totalPages}
              </div>

              <nav>
                <ul className="pagination mb-0">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{
                        ...paginationBtnStyle,
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        opacity: currentPage === 1 ? 0.5 : 1,
                      }}
                    >
                      السابق
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, i) => (
                    <li key={i}>
                      <button
                        onClick={() => handlePageChange(i + 1)}
                        style={{
                          ...paginationBtnStyle,
                          background:
                            currentPage === i + 1 ? "#2563eb" : "#fff",
                          color:
                            currentPage === i + 1 ? "#fff" : "#475569",
                          fontWeight: currentPage === i + 1 ? "600" : "500",
                        }}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{
                        ...paginationBtnStyle,
                        cursor:
                          currentPage === totalPages ? "not-allowed" : "pointer",
                        opacity: currentPage === totalPages ? 0.5 : 1,
                      }}
                    >
                      التالي
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            background: "#fff",
            border: "1px solid #dbeafe",
            borderRadius: "8px",
            padding: "60px 20px",
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
          }}
        >
          <i
            className="bi bi-bell-slash"
            style={{ fontSize: "64px", color: "#94a3b8", marginBottom: "20px" }}
          ></i>
          <h4 style={{ color: "#475569", fontWeight: "600", marginBottom: "8px" }}>
            لا توجد إشعارات
          </h4>
          <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>
            كل شيء على ما يرام 🚀
          </p>
        </div>
      )}
    </div>
  );
}

// Styles
const thStyle = {
  color: "#1e40af",
  fontSize: "14px",
  padding: "12px 8px",
  fontWeight: "600",
  border: "1px solid #bfdbfe",
};

const tdStyle = {
  padding: "12px 8px",
  border: "1px solid #e0e7ff",
  fontSize: "17px",
  fontWeight: "600",
  color: "#475569",
};

const actionBtnStyle = (color) => ({
  background: color,
  color: "#fff",
  padding: "6px 12px",
  borderRadius: "6px",
  border: "none",
  fontWeight: "600",
  fontSize: "13px",
  cursor: "pointer",
  transition: "all 0.3s ease",
});

const paginationBtnStyle = {
  padding: "8px 14px",
  margin: "0 3px",
  border: "1px solid #bfdbfe",
  borderRadius: "6px",
  fontSize: "14px",
  cursor: "pointer",
  transition: "all 0.2s ease",
};
